import { Loader2 } from 'lucide-react'

import { cn } from '@/lib/utils'

interface SpinnerProps {
  className?: string
  size?: number
  label?: string
}

export function Spinner({ className, size = 16, label }: SpinnerProps) {
  return (
    <span
      role="status"
      aria-live="polite"
      className={cn('inline-flex items-center gap-2', className)}
    >
      <Loader2 size={size} className="animate-spin" aria-hidden="true" />
      {label !== undefined ? <span className="sr-only">{label}</span> : null}
    </span>
  )
}
